import React, { useCallback, Fragment } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useDataLayer } from 'hooks/useDataLayer';
import { Icon } from 'roo-ui/components';
import { getIsAuthenticated } from 'store/user/userSelectors';
import { fixBodyScroll, unfixBodyScroll } from 'lib/browser';
import { QffMenuWrapper, QffMenuButtonWrapper, QffMenuButton } from './primitives';
import { getQffAuth } from 'lib/qffAuth';
import QffMenuContent from './QffMenuContent';

const login = async () => {
  try {
    const qffAuth = await getQffAuth();
    qffAuth.showLoginModal();
  } catch (e) {
    //do nothing yet
  }
};

const QffMenu = ({ isQffMenuOpen, setIsPhoneMenuOpen, setIsQffMenuOpen }) => {
  const { emitInteractionEvent } = useDataLayer();

  const isAuthenticated = useSelector(getIsAuthenticated);
  const isOpen = isQffMenuOpen;

  const handleLoginClick = useCallback(() => {
    login();

    setIsPhoneMenuOpen(false);
    setIsQffMenuOpen(false);

    emitInteractionEvent({ type: 'QFF Login Button', value: 'Mobile Log In Button Selected' });
  }, [emitInteractionEvent, setIsPhoneMenuOpen, setIsQffMenuOpen]);

  const onLogout = useCallback(() => {
    setIsPhoneMenuOpen(false);
    setIsQffMenuOpen(false);
    unfixBodyScroll();
  }, [setIsPhoneMenuOpen, setIsQffMenuOpen]);

  const toggleQffMenu = useCallback(() => {
    const newIsOpen = !isOpen;

    emitInteractionEvent({ type: 'QFF Login Dropdown', value: `Mobile Dropdown ${newIsOpen ? 'Expanded' : 'Collapsed'}` });

    setIsPhoneMenuOpen(false);
    setIsQffMenuOpen(newIsOpen);

    if (newIsOpen) {
      fixBodyScroll();
    } else {
      unfixBodyScroll();
    }
  }, [emitInteractionEvent, isOpen, setIsPhoneMenuOpen, setIsQffMenuOpen]);

  return (
    <Fragment>
      <QffMenuButtonWrapper>
        {isAuthenticated && !isOpen && (
          <QffMenuButton onClick={toggleQffMenu} data-testid="show-details-button">
            <Icon name="person" />
          </QffMenuButton>
        )}
        {isAuthenticated && isOpen && (
          <Fragment>
            <QffMenuButton onClick={toggleQffMenu} data-testid="close-button">
              <Icon name="close" />
            </QffMenuButton>
            <QffMenuWrapper>
              <QffMenuContent onLogout={onLogout} />
            </QffMenuWrapper>
          </Fragment>
        )}

        {!isAuthenticated && (
          <QffMenuButton onClick={handleLoginClick} data-testid="login-button">
            Log in
          </QffMenuButton>
        )}
      </QffMenuButtonWrapper>
    </Fragment>
  );
};

QffMenu.propTypes = {
  isQffMenuOpen: PropTypes.bool.isRequired,
  setIsPhoneMenuOpen: PropTypes.func.isRequired,
  setIsQffMenuOpen: PropTypes.func.isRequired,
};

export default QffMenu;
